import { Component, OnInit, Optional } from '@angular/core';
import { MetaDirective } from '../../shared/directives/meta.directive';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { SearchStateService } from '../../shared/services/search-state.service';
import { SearchMode } from '../../shared/enum/searchMode';
import { ContentHeaderComponent } from '../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { GrundstueckSucheStandardComponent } from './grundstueck-suche-standard/grundstueck-suche-standard.component';
import { GrundstueckSucheErweitertComponent } from './grundstueck-suche-erweitert/grundstueck-suche-erweitert.component';
import { GrundstueckSucheEgridComponent } from './grundstueck-suche-egrid/grundstueck-suche-egrid.component';
import { TranslatePipe } from '@ngx-translate/core';
import { GrundstueckDetailEntryMeta } from '../../core/gb-api';
import GrundstueckArtEnum = GrundstueckDetailEntryMeta.GrundstueckArtEnum;
import SdrArtEnum = GrundstueckDetailEntryMeta.SdrArtEnum;

@Component({
  selector: 'cap-grundstueck-suche',
  templateUrl: './grundstueck-suche.component.html',
  styleUrls: ['./grundstueck-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    GrundstueckSucheStandardComponent,
    GrundstueckSucheErweitertComponent,
    GrundstueckSucheEgridComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class GrundstueckSucheComponent implements OnInit {
  searchMode: SearchMode;

  tabErweitertActive: boolean;

  constructor(
    private stateService: SearchStateService,
    @Optional() private metaDirective?: MetaDirective
  ) {
    keysToTranslate<string>([
      'Standardsuche',
      'ErweiterteSuche',
      'EgridSuche',
      'Unterart',
      'Liegenschaft',
      'SelbststaendigesUndDauerndesRechtMitAbkuerzung',
      'Stockwerkeigentum',
      'Miteigentumsanteil',
      'version',
      'GrundstueckNummer',
      'Grundstuecksart',
      'Zustand',
      'StrasseOderFlurnameHausnummer',
      'Ortschaft',
      'grundstueck.SucheTitel',
      'grundstueck.search.breadcrumb'
    ]);
    keysToTranslate<GrundstueckArtEnum | SdrArtEnum>([
      'STOCKWERK',
      'LIEGENSCHAFT',
      'MITEIGENTUM',
      'UNBEKANNT',
      'FOLIO',
      'BERGWERK',
      'SDR',
      'BAURECHT',
      'KONZESSION',
      'QUELLENRECHT',
      'UEBRIGES_RECHT'
    ]);
  }

  ngOnInit() {
    this.searchMode = this.stateService.lastSearchMode || SearchMode.searchStandard;
  }

  saveTabSettings(event: boolean) {
    this.tabErweitertActive = event;
  }
}
